<template>
    <ProfileOptionSelector :model="'region'" :nextRoute="() => 'SmokingPage'" />
</template>

<script>
export default {
    name: 'RegionPage',
    mounted() {
        this.$nativeBridge.postMessage({
            action: 'sendFirebaseEvent',
            value: {
                category: 'RegionPage_Enter_RegionPage',
                option: {
                    provider: this.$store.getters.payloads.signupData.provider || 'email',
                },
            },
        })
    },
}
</script>
